import api from "@/common/js/api";
import store from "@store/tender";
import _ from 'lodash'
import { h } from 'vue'

export const HouseState = {
  BZJ_ADDRESS: ["政和县", "松溪县", "厦门航空", "光泽县", "永定区", "福清市", "龙岩市", "自主招标", "福建省国资采购平台", "将乐县国投公司招投标采购服务平台", "福建省国资采购平台（福清）", "福州市仓山区"],
  CUSTOM_BANK_ACCOUNT: ["其他账户"]
}

export const get_TENDER_PLATFORMS = () => {
  return {
    GGFW: `福建省公共资源交易电子公共服务平台（网址：ggzyfw.fujian.gov.cn和ggzyfw.fj.gov.cn）`,
    DZJY: `${PlateFormOptions.type}电子招标投标交易平台（网址：${PlateFormOptions.web}）`,
    GZCG: `、福建省国资采购平台（网址：https://ygcg.fjcqjy.com/）`
  }
}

export const HouseUtils = {
  initBondInfo (form) {
    form.isBondOnline = form.isHasBond = HouseState.BZJ_ADDRESS.indexOf(form.region) >= 0
  },
  changeAreaRadio(form, regions) { // 场内标选择交易中心
    form.isHasBond = HouseState.BZJ_ADDRESS.indexOf(form.areaRadio) >= 0
    form.isBondOnline = form.BOND_BANKS_SELECT.reduce((pre, cur) => {
      return pre && HouseState.CUSTOM_BANK_ACCOUNT.indexOf(cur) === -1
    }, form.isHasBond)

    if(!form.isHasBond) form.BOND_BANKS_SELECT = []

    form.OPENING_BANK = ''
    form.ACCOUNT_NAME = ''
    form.ACCOUNT_NUMBER = ''
    form.BOND_BANKS = []
    form.BOND_BANKS_SELECT = []

    if(form.regionId === 'x60005') {
      form.TRADE_CENTER = {Value: 'x60005', Name: '福清市'}
    } else if (form.regionId === 'x60010') {
      form.TRADE_CENTER = {Value: 'x60010', Name: '龙岩市'}
    } else {
      console.log(regions)
    }
  },
  changeBondBanks(form) { // 保证金银行选择
    form.isBondOnline = true
    let xIndex = form.BOND_BANKS_SELECT.reduce((pre, cur, index) => {
      return HouseState.CUSTOM_BANK_ACCOUNT.indexOf(cur) >= 0 ? index : pre
    }, -1)
    if(xIndex === form.BOND_BANKS_SELECT.length - 1) {
      form.isBondOnline = false
      if(xIndex > 0) form.BOND_BANKS_SELECT.splice(0, form.BOND_BANKS_SELECT.length - 1)
    } else if(xIndex >= 0) {
      form.BOND_BANKS_SELECT.splice(xIndex, 1)
    }
  },
  isInBzjAddress(form) {
    return new Promise((resolve, reject) => {
      if(HouseState.BZJ_ADDRESS.indexOf(form.region) >= 0) {
        resolve()
      } else {
        reject()
      }
    })
  },
  setReportCtbaName(form, CreatedBy) {
    if(form.IS_REPORT_CTBA_NAME === undefined) {
      form.IS_REPORT_CTBA_NAME = CreatedBy.UserName
    }
  },
  resetBondBanks(form, {state, config, isOnlySet}) {
    if(form.BOND_BANKS_SELECT.length) {
      HouseUtils.changeBondBanks(form)
    }
    if(form.isBondOnline && !isOnlySet) {
      form.BOND_BANKS_SELECT.forEach(value => {
        state.selections.bankOptions.forEach(obj => {
          if(obj.NAME === value) {
            if(['勘察', '建筑设计', '市政设计'].indexOf(form.type) >= 0) {
              form.MARGIN_BANK = form.MARGIN_BANK ? `${form.MARGIN_BANK}，${obj.NAME}` : obj.NAME
              form.MARGIN_NAME = form.MARGIN_NAME ? `${form.MARGIN_NAME}，${obj.MAIN_NAME}` : obj.MAIN_NAME
              form.MARGIN_NUMBER = '在线获取保证金子账号'         
            } else {
              form.OPENING_BANK = form.OPENING_BANK ? `${form.OPENING_BANK}，${obj.NAME}` : obj.NAME
              form.ACCOUNT_NAME = form.ACCOUNT_NAME ? `${form.ACCOUNT_NAME}，${obj.MAIN_NAME}` : obj.MAIN_NAME
              form.ACCOUNT_NUMBER = '在线获取保证金子账号'              
            }
            form.BOND_BANKS.push(obj)
          }
        }) 
      })
    }
    let disabled = form.BOND_BANKS_SELECT[0] !== '其他账户'
    if(['勘察', '建筑设计', '市政设计'].indexOf(form.type) >= 0) {
      config['/1/section-02'].MARGIN_BANK.Disabled = disabled
      config['/1/section-02'].MARGIN_NAME.Disabled = disabled
      config['/1/section-02'].MARGIN_NUMBER.Disabled = disabled

      config['/2/section-02'].MARGIN_BANK.Disabled = disabled
      config['/2/section-02'].MARGIN_NAME.Disabled = disabled
      config['/2/section-02'].MARGIN_NUMBER.Disabled = disabled  
      return false
    }
    if(form.type === '监理') {
      config['/7/section-01'].OPENING_BANK.Disabled = disabled
      config['/7/section-01'].ACCOUNT_NAME.Disabled = disabled
      config['/7/section-01'].ACCOUNT_NUMBER.Disabled = disabled  
    } else {
      config['/9/section-01'].OPENING_BANK.Disabled = disabled
      config['/9/section-01'].ACCOUNT_NAME.Disabled = disabled
      config['/9/section-01'].ACCOUNT_NUMBER.Disabled = disabled  
    }

    config['/2/section-02'].OPENING_BANK.Disabled = disabled
    config['/2/section-02'].ACCOUNT_NAME.Disabled = disabled
    config['/2/section-02'].ACCOUNT_NUMBER.Disabled = disabled  
  },
  getDefaultMargins(form) {
    let defaultMargins = []
    switch(form.regionId) {
      case '350722': // 浦城
      case '350723': // 光泽
      case '350724': // 松溪
      case '350725': // 政和
      case '350783': // 建瓯
        defaultMargins = [
          '银行保函', 
          '保险公司出具的投标保证保险', 
          '工程担保公司出具的担保保函'
        ]
        break;
      default:
        defaultMargins = []
        break;
    }
    return defaultMargins
  },
  getMarginPayTypeForPc(form) {
    let res = ['现金', '银行保函', '工程担保公司出具的担保保函', '保险公司出具的投标保证保险', '年度投标保证金']
    let {MARGIN_PAY_TYPE} = form
    if(MARGIN_PAY_TYPE.indexOf('福建省建筑业龙头企业年度投标保证金形式') >= 0) {
      res.push('福建省建筑业龙头企业年度投标保证金形式')
    }
    return res.reduce((pre, cur) => [...pre, {Name: cur, Value: cur}], [])
  },
  resetNoticeMedia(form) {
    let TENDER_PLATFORMS = get_TENDER_PLATFORMS()
    let { regionId, REGION_CODE, isReportedFujianProvinceProperty } = form
    if(regionId === 'x00004') {
      if(/^35\d{4}$/.test(REGION_CODE) && isReportedFujianProvinceProperty) {
        form.NOTICE_MEDIA3 = `${TENDER_PLATFORMS.GGFW}、${TENDER_PLATFORMS.DZJY}${TENDER_PLATFORMS.GZCG}`
      } else {
        form.NOTICE_MEDIA3 = `${TENDER_PLATFORMS.GGFW}、${TENDER_PLATFORMS.DZJY}`
      }
    }
  }
}

export const TenderCheckedUtils = {
  $vm: null,
  state: {
    modify: false,
    price: '',
    priceTemp: '',
    area: '',
    areaTemp: '',
    actions: [],
    message: '',
    form: {}
  },
  initPriceAndArea(form, price, area) {
    let { state } = this
    state.form = form
    state.price = state.priceTemp = price
    state.area = state.areaTemp = area
  },
  setActions(actions) {
    let { state, $vm } = this
    state.actions = actions
    state.modify = false
    $vm.checkedModify = false
    // this.initPriceAndArea(state.priceTemp, state.areaTemp)
  },
  setPrice(price) {
    let { state } = this
    state.price = price
    this.checkModify()
  },
  setArea(area) {
    let { state } = this
    state.area = area
    this.checkModify()
  },
  checkModify() {
    let { price, priceTemp, area, areaTemp } = this.state
    this.state.modify = !(price === priceTemp && area === areaTemp)
    this.$vm.checkedModify = this.state.modify
    this.disabledPublish()
  },
  disabledPublish() {
    let { modify, price, priceTemp, area, areaTemp, actions, form } = this.state
    actions.forEach(action => {
      if(/^(送审|发布)$/.test(action.actionName)) {
        action.available = !modify
        action.actionContent.Msg = this.$vm.checkedMessage = this.state.message = this.getPriceName({
          form,
          price: price !== priceTemp,
          area: area !== areaTemp
        })
      }
    })
  },
  getPriceName({form, price, area}) {
    let text = ''
    let keys = []
    switch(form.type) {
      case '工程总承包': text = '最高投标限价'; break;
      case '勘察': text = '工程勘察收费金额'; break;
      case '建筑设计':
      case '市政设计': text = '估算的工程设计收费金额'; break;
      default: text = '招标控制价'
    }
    if(price) keys.push(text)
    if(area) keys.push('项目所在行政区域代码')
    return `检测到【${keys.join('，')}】发生变化，可能影响后续流程，请先【暂存】页面数据`
  }
}

export const SiteBookingUtils = {
  firstValue: '',
  host: '',
  msg: '',
  validRes: null,
  stateOptions: {
    3: '取消',
    4: '退回',
    5: '使用',
    6: '临时预约',
  },
  getHost() {
    return new Promise((resolve, reject) => {
      if(this.host) {
        resolve()
      } else {
        api.get('/static/config/siteBookingServelUrl.json').then(res => {
          this.host = res.siteBookingServelUrl
          resolve()
        }).catch(e => null)
      }
    })
  },
  valid(form, callback) {
    let value = form.SITE_BOOKING_NUM
    let {firstValue, msg} = this
    if(firstValue === value) {
      msg ? callback(new Error(msg)) : callback()
      setTimeout(() => {
        store.dispatch('calcTenderCount')
      }, 100)
    } else {
      this.firstValue = value
      if(value) {
        this.remoteValid(form, callback)
      } else {
        this.msg = ' '
        callback(new Error(this.msg))
      }
    }
  },
  remoteValid(form, callback) {
    let {stateOptions} = this
    let value = form.OPEN_BID_SITE
    let res = this.validRes
    if(res) {
      if(res.status === -1) return callback(new Error(res.msg))
      let {fetchCenterInfoStatus, state, centerData} = res.order
      if (fetchCenterInfoStatus && state == 200) {
        if(centerData.id === value) {
          let extraData = JSON.parse(centerData.extraData)
          form.BID_OPEN_PLACE = extraData.Address
          this.msg = ''
          callback()
        } else {
          this.msg = '该编号与开标场地不匹配，请重新填写'
          callback(new Error(this.msg))
        }
      } else {
        state = stateOptions[state] || '审核中'
        ElMessageBox({
          title: "数据验证",
          closeOnClickModal: false,
          type: "warning",
          showCancelButton: false,
          confirmButtonText: "确定",
          message: h("p", { style: "font-weight:bolder" }, [
            h("span", null, "当前预约订单状态为"),
            h("span", { style: "color: red" }, state),
            h("span", null, "状态，不可使用，请重新输入订单状态为"),
            h("span", { style: "color: red" }, "预约成功"),
            h("span", null, "的场地预约编号！"),
          ]),
        }).then(() => {
          ElMessage.warning("请填写有效的场地预约编号！");
        }).catch(e => null)
        this.msg = '请填写有效的场地预约编号！'
        callback(new Error(this.msg));
      }
    } else {
      callback()
    }
  },
  newValid(form) {
    this.getHost().then(() => {
      let {host} = this
      let value = form.SITE_BOOKING_NUM
      if(!value) return false
      api.get(`${host}/Api/v1/Book/ExistValidOrder`, {
        Id: value
      }).then(res => {
        this.validRes = res
        store.dispatch('setValidatorCount')
      }).catch(e => null)
    }).catch(e => null)
  }
}

export const MarginUtils = {
  noText: '①②③④⑤⑥⑦⑧⑨⑩⑪⑫⑬⑭⑮⑯⑰⑱⑲⑳',
  initOptions(form) {
    let options =  []
    let isOutSite = form.regionId.indexOf('x') === 0
    switch(form.type) {
      case '施工':
        options = [
          '现金', '银行保函', '工程担保公司出具的担保保函', '保险公司出具的投标保证保险',
          '年度投标保证金', '免缴投标保证金', '其他'
        ]
        // if (!isOutSite) options.push('')
        // options.push('')
        // if (form.version < 20240320 || !isOutSite) options.push('')
        break;
      case '监理':
        options = [
          '现金', '银行保函', '工程担保公司出具的担保保函', '保险公司出具的投标保证保险', '年度投标保证金'
        ]
        break;
      case '勘察':
      case '建筑设计':
      case '市政设计':
      case '园林绿化':
        options = [
          '现金', '银行保函', '工程担保公司出具的担保保函', '保险公司出具的投标保证保险', 
          '福建省建筑业龙头企业年度投标保证金形式', '年度投标保证金'
        ]
        break;
      case '工程总承包':
        options = [
          '现金', '银行保函', '工程担保公司出具的担保保函', '保险公司出具的投标保证保险', '年度投标保证金'
        ]
        break;
    }
    options = options.map(x => ({
      Name: x, Value: x, Hidden: false
    }))
    if(isOutSite) {
      // options = options.filter(x => x.Name!== '年度投标保证金')
      options.forEach(x => {
        x.Hidden = x.Name === '年度投标保证金'
      })
      if (form.type === '施工' && form.version >=20240320) {
        options = options.filter(x => x.Name!== '其他')
      }
    }
    return options
  },
  initNoOptions(form) {
    let options =  []
    let isOutSite = form.regionId.indexOf('x') === 0
    switch(form.type) {
      case '施工':
        options = [
          '现金形式', '银行保函形式', '工程担保公司出具的担保保函形式', '保险公司出具的投标保证保险形式', '年度投标保证金形式', '免缴投标保证金形式', '其他形式'
        ]
        // if (!isOutSite) options.push('') // 场外标本就不包含
        // options.push('') // 保函
        // if (form.version < 20240320 || !isOutSite) options.push('') // 20240430之后的不包含
        break;
      case '监理':
        options = [
          '现金形式', '银行保函形式', '年度投标保证金形式', 
          '工程担保公司出具的担保保函形式', '保险公司出具的投标保证保险形式'
        ]
        break;
      case '勘察':
      case '建筑设计':
      case '市政设计':
      case '园林绿化':
        options = [
          '现金形式', '银行保函形式', '工程担保公司出具的担保保函形式', '保险公司出具的投标保证保险形式', 
          '福建省建筑业龙头企业年度投标保证金形式', '年度投标保证金形式'
        ]
        break;
      case '工程总承包':
        options = [
          '现金形式', '银行保函形式', '工程担保公司出具的担保保函形式', '保险公司出具的投标保证保险形式', '年度投标保证金形式'
        ]
        break;
    }
    options = options.map((x, i) => ({
      Name: `${this.noText[i]}${x}`, Value: i + 1, Hidden: false
    }))
    if(isOutSite) {
      // options = options.filter(x => x.Name.indexOf('年度投标保证金形式') !== 1)
      options.forEach(x => {
        x.Hidden = x.Name.indexOf('年度投标保证金形式') === 1
      })
      if (form.type === '施工' && form.version >=20240320) {
        options = options.filter(x => x.Name.indexOf('其他形式') !==1)
      }
    }
    return options
  },
  resetMarginPayTypeOther(form) {
    if (form.version >= 20240320 && form.regionId.indexOf('x') === 0) {
      form.MARGIN_PAY_OTHER_TYPE = '/'
    }
  },
  removeMarginPayTypeOther(form) {
    if (form.version >= 20240320 && form.regionId.indexOf('x') === 0) {
      form.MARGIN_PAY_TYPE.forEach((x, i) => {
        if (x === '其他') form.MARGIN_PAY_TYPE.splice(i, 1)
      })
      form.MARGIN_PAY_TYPE_SIGNOUT_NO.forEach((x, i) => {
        if (x === '7') form.MARGIN_PAY_TYPE_SIGNOUT_NO.splice(i, 1)
      })
    }
  }
}

export default {}